import * as plugin_0 from '@/app.js';
import * as plugin_1 from '@@/plugin-dva/runtime.js';
import * as plugin_2 from '@@/plugin-locale/runtime.js';
import * as plugin_3 from '@@/plugin-dva/runtime.js';
import * as plugin_4 from '@@/plugin-locale/runtime.js';

const plugins = [
  plugin_0,
  plugin_1,
  plugin_2,
  plugin_3,
  plugin_4,
].filter(Boolean);

export function applyRuntimePlugins(opts) {
  return plugins.reduce((memo, plugin) => {
    if (plugin && typeof plugin.rootContainer === 'function') {
      return plugin.rootContainer(memo, opts);
    }
    return memo;
  }, opts.element);
}

export async function getInitialState() {
  for (const plugin of plugins) {
    if (plugin && typeof plugin.getInitialState === 'function') {
      return plugin.getInitialState();
    }
  }
  return undefined;
}

export function onRouteChange(args) {
  plugins.forEach((plugin) => {
    if (plugin && typeof plugin.onRouteChange === 'function') {
      plugin.onRouteChange(args);
    }
  });
}

export { plugins };
